<template>
    <div name="ranking" class="ranking">
        <toast 
            v-if="isToast"
            @close="isToastClose"
        />
        <post
            v-if="isPost"
            @onClose="closePost"
            @onSubmit="submitUncomfortable"
        />
        <ranking-banner 
            @postUncomfortable="postUncomfortable"
        />
        <list 
            @login="loginWithoutPost"
            @like="likeSubmit"
            @change="typeChange"
        />
    </div>
</template>

<script>
import Constant from '@/constant';
import {mapState} from 'vuex'
import RankingBanner from '@/components/organisms/m_uncomfortable/RankingBanner';
import List from '@/components/organisms/m_uncomfortable/list'
import Cookie from '@/utilities/cookie';
import CampaignAuth from '@/utilities/campaignAuth';
import Post from '@/components/organisms/m_uncomfortable/Post'
import Toast from '@/components/molecules/m_uncomfortable/Toast';

export default {
    components: { RankingBanner, List, Post, Toast },
    name: 'ranking',
    computed: mapState(['vocPage', 'vocLoginKakaoToken', 'vocDiabetes']),
    data: function()
    {
        return {
            curPage: 1,
            totalCount: 0,
            pageCount: 2000,
            isPost: false,
            isToast: false,
            type: 'createdAt'
        }
    },
    mounted: function()
    {
        // load voc diabetes page 

        this.$store.dispatch(Constant.FETCH_DIABETES_VOC_PAGE, {pageno: this.curPage, pagesize: this.pageCount, sort: this.type})
            .then((res) => {
                this.totalCount = this.vocPage.totalcount;
            })
            .catch((err) => {

            })

        this.$store.commit(Constant.SET_VOC_LOGIN_KAKAO_TOKEN, {token: CampaignAuth.getToken()});

        if(this.$route.query.ispost === "true")
        {
            this.$router.push('/m/campaign/ranking');
            this.isPost = true;
            // post open
        }
    },
    methods: {
        postUncomfortable: function()
        {
            const token = CampaignAuth.getToken()
            this.$store.commit(Constant.SET_VOC_LOGIN_KAKAO_TOKEN, {token: token});
            if(token === null)
            {
                this.login();
            }
            else
            {
                //open 
                this.isPost = true;
            }
            // 유효한 카카오 토큰이 있는지 확인

        },
        login: function()
        {
            CampaignAuth.login(`/m/campaign/ranking?ispost=true`);
        },
        loginWithoutPost: function()
        {
            CampaignAuth.login(`/m/campaign/ranking`);
        },
        typeChange: function(type)
        {
            this.type = type;
            this.$store.dispatch(Constant.FETCH_DIABETES_VOC_PAGE, {pageno: this.curPage, pagesize: this.pageCount, sort: this.type})
                .then((res) => {
                    this.totalCount = this.vocPage.totalcount;
                })
                .catch((err) => {

                })
        },
        likeSubmit: function(id)
        {

            this.$store.commit(Constant.INITIALIZE_DIABETES_VOC)
            this.vocDiabetes.id = id;
            this.$store.dispatch(Constant.UPDATE_DIABETES_VOC)
                .then((res) => {
                    this.$store.dispatch(Constant.FETCH_DIABETES_VOC_PAGE, {pageno: this.curPage, pagesize: this.pageCount, sort: this.type})
                        .then((res) => {
                            this.totalCount = this.vocPage.totalcount;
                        })
                        .catch((err) => {

                        })

                    // like local storage 처리
                    let likedata = JSON.parse(Cookie.getLocalStorageWithExpire("voclike"));
                    if(likedata === null)
                    {
                        likedata = {};
                    }
                    Cookie.updateOrAddValue(likedata, this.vocLoginKakaoToken, id);
                    Cookie.setLocalStorageWithExpire("voclike", JSON.stringify(likedata))
                    this.isToast = true;

                    //isToast 
                })
                .catch((err) => {

                })
        },
        isToastClose: function()
        {
            this.isToast = false;
        },
        closePost: function()
        {
            this.isPost = false;
        },
        submitUncomfortable: function(yearCount, contents)
        {
            this.$store.dispatch(Constant.FETCH_DIABETES_VOC_PAGE, {pageno: this.curPage, pagesize: this.pageCount, sort: this.type})
                .then((res) => {
                    this.totalCount = this.vocPage.totalcount;
                })
                .catch((err) => {

                })

            this.isPost = false;

        }
    }
}
</script>

<style scoped>
    .ranking {
        width: 100%;
        padding-top: 56px;
    }
</style>


// WEBPACK FOOTER //
// src/page/m_uncomfortable/Rankings.vue